import React from "react";

const MinusFilledIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M16.1667 11.1667V12.8333H7.83333V11.1667H16.1667ZM22 12C22 17.5142 17.5142 22 12 22C6.48583 22 2 17.5142 2 12C2 6.48583 6.48583 2 12 2C17.5142 2 22 6.48583 22 12ZM17.8333 11.1667C17.8333 10.2475 17.0858 9.5 16.1667 9.5H7.83333C6.91417 9.5 6.16667 10.2475 6.16667 11.1667V12.8333C6.16667 13.7525 6.91417 14.5 7.83333 14.5H16.1667C17.0858 14.5 17.8333 13.7525 17.8333 12.8333V11.1667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MinusFilledIcon;
